import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-tickets',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.scss']
})
export class MyTicketsComponent implements OnInit {
  @ViewChild('messagesEnd') messagesEnd!: ElementRef;

  profileId = localStorage.getItem('profileId') || '';
  tickets: any[] = [];
  loading = false;

  selectedTicket: any = null;
  loadingThread = false;
  replyText = '';
  sendingReply = false;
  closingTicket = false;

  statusFilter = 'ALL';
  statuses = ['ALL', 'New', 'In Progress', 'Waiting for User', 'Resolved', 'Closed'];

  constructor(private apiService: ApiServiceService, private router: Router) {}

  ngOnInit(): void {
    if (!this.profileId) {
      this.router.navigate(['/login']);
      return;
    }
    
    this.loadTickets();
  }
  goBack(): void {
  window.history.back();
}

  loadTickets(): void {
    this.loading = true;
    this.apiService.getUserTickets(this.profileId).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.status === 'success') this.tickets = res.data || [];
      },
      error: () => { this.loading = false; }
    });
  }

  get filteredTickets(): any[] {
    if (this.statusFilter === 'ALL') return this.tickets;
    return this.tickets.filter(t => t.status === this.statusFilter);
  }

  getStatusCount(s: string): number {
    if (s === 'ALL') return this.tickets.length;
    return this.tickets.filter(t => t.status === s).length;
  }

  openTicket(ticket: any): void {
    this.selectedTicket = ticket;
    this.replyText = '';
    this.loadingThread = true;
    this.apiService.getTicketById(ticket.ticket_id, this.profileId).subscribe({
      next: (res) => {
        this.loadingThread = false;
        if (res.status === 'success') {
          this.selectedTicket = res.data;
          setTimeout(() => this.scrollToBottom(), 100);
        }
      },
      error: () => { this.loadingThread = false; }
    });
  }

  closePanel(): void {
    this.selectedTicket = null;
    this.replyText = '';
  }

  sendReply(): void {
    if (!this.replyText.trim() || this.sendingReply) return;
    this.sendingReply = true;
    this.apiService.addTicketReply(this.selectedTicket.ticket_id, this.profileId, this.replyText.trim()).subscribe({
      next: (res) => {
        this.sendingReply = false;
        if (res.status === 'success') {
          const msg = res.data;
          this.selectedTicket.messages = [...(this.selectedTicket.messages || []), msg];
          this.selectedTicket.status = 'In Progress';
          this.replyText = '';
          setTimeout(() => this.scrollToBottom(), 80);
          // update in list too
          const idx = this.tickets.findIndex(t => t.ticket_id === this.selectedTicket.ticket_id);
          if (idx !== -1) this.tickets[idx].status = 'In Progress';
        }
      },
      error: (err) => {
        this.sendingReply = false;
        alert(err.error?.message || 'Failed to send reply.');
      }
    });
  }

  requestClose(): void {
    if (this.closingTicket) return;
    if (!confirm('Are you sure you want to close this ticket? You can always open a new one if needed.')) return;
    this.closingTicket = true;
    this.apiService.closeTicket(this.selectedTicket.ticket_id, this.profileId).subscribe({
      next: () => {
        this.closingTicket = false;
        this.selectedTicket.status = 'Closed';
        const idx = this.tickets.findIndex(t => t.ticket_id === this.selectedTicket.ticket_id);
        if (idx !== -1) this.tickets[idx].status = 'Closed';
      },
      error: (err) => {
        this.closingTicket = false;
        alert(err.error?.message || 'Failed to close ticket.');
      }
    });
  }

  scrollToBottom(): void {
    try {
      this.messagesEnd?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    } catch (_) {}
  }

  trackByMsg(_: number, msg: any): string { return msg._id || msg.created_at; }

  getStatusClass(status: string): string {
    const map: any = {
      'New': 'badge-new',
      'In Progress': 'badge-progress',
      'Waiting for User': 'badge-waiting',
      'Resolved': 'badge-resolved',
      'Closed': 'badge-closed'
    };
    return map[status] || 'badge-new';
  }

  getPriorityClass(priority: string): string {
    const map: any = {
      'Low': 'pri-low',
      'Medium': 'pri-medium',
      'High': 'pri-high',
      'Urgent': 'pri-urgent'
    };
    return map[priority] || 'pri-medium';
  }

  getCategoryIcon(cat: string): string {
    const map: any = {
      'Payment': 'payments',
      'Profile': 'manage_accounts',
      'Verification': 'verified_user',
      'Technical Issue': 'build',
      'Broker': 'handshake',
      'Other': 'help'
    };
    return map[cat] || 'help';
  }
}
